"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "torino": {
    "70281dc0": [{
      "hkey": "020c3495",
      "slug": "barriera-di-milano-rebaudengo",
      "name": "Barriera di Milano, Rebaudengo",
      "primary": true,
      "skipSearch": false
    }],
    "fuori-torino": [{
      "hkey": "020c3495",
      "slug": "barriera-di-milano-rebaudengo",
      "name": "Barriera di Milano, Rebaudengo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c8cc790d": [{
      "hkey": "020c3495",
      "slug": "barriera-di-milano-rebaudengo",
      "name": "Barriera di Milano, Rebaudengo",
      "primary": true,
      "skipSearch": false
    }],
    "barriera-milano": [{
      "hkey": "020c3495",
      "slug": "barriera-di-milano-rebaudengo",
      "name": "Barriera di Milano, Rebaudengo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "aca9336e": [{
      "hkey": "355e6d5e",
      "slug": "borgo-vittoria-madonna-di-campagna",
      "name": "Borgo Vittoria, Madonna Di Campagna",
      "primary": true,
      "skipSearch": false
    }],
    "borgata-vittoria": [{
      "hkey": "355e6d5e",
      "slug": "borgo-vittoria-madonna-di-campagna",
      "name": "Borgo Vittoria, Madonna Di Campagna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torino"
    }],
    "281c3bee": [{
      "hkey": "d023af7d",
      "slug": "campidoglio-cit-turin-san-donato",
      "name": "Campidoglio, Cit Turin, San Donato",
      "primary": true,
      "skipSearch": false
    }],
    "campidoglio": [{
      "hkey": "d023af7d",
      "slug": "campidoglio-cit-turin-san-donato",
      "name": "Campidoglio, Cit Turin, San Donato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torino"
    }],
    "f4e66fe2": [{
      "hkey": "be7006ff",
      "slug": "borgo-san-paolo-cenisia",
      "name": "Borgo San Paolo, Cenisia",
      "primary": true,
      "skipSearch": false
    }],
    "cenisia": [{
      "hkey": "be7006ff",
      "slug": "borgo-san-paolo-cenisia",
      "name": "Borgo San Paolo, Cenisia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torino"
    }],
    "295220eb": [{
      "hkey": "82202831",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "centro-giardini-reali-repubblica": [{
      "hkey": "82202831",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torino"
    }],
    "5908a40e": [{
      "hkey": "d023af7d",
      "slug": "campidoglio-cit-turin-san-donato",
      "name": "Campidoglio, Cit Turin, San Donato",
      "primary": true,
      "skipSearch": false
    }],
    "cit-turin": [{
      "hkey": "d023af7d",
      "slug": "campidoglio-cit-turin-san-donato",
      "name": "Campidoglio, Cit Turin, San Donato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torino"
    }],
    "2bd81479": [{
      "hkey": "47b88046",
      "slug": "crocetta-san-secondo",
      "name": "Crocetta, San Secondo",
      "primary": true,
      "skipSearch": false
    }],
    "crocetta": [{
      "hkey": "47b88046",
      "slug": "crocetta-san-secondo",
      "name": "Crocetta, San Secondo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torino"
    }],
    "e07ade34": [{
      "hkey": "b7d23f7e",
      "slug": "lucento-vallette-juventus-stadium",
      "name": "Lucento, Vallette, Juventus Stadium",
      "primary": true,
      "skipSearch": false
    }],
    "le-vallette-lucento-juventus-stadium": [{
      "hkey": "b7d23f7e",
      "slug": "lucento-vallette-juventus-stadium",
      "name": "Lucento, Vallette, Juventus Stadium",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torino"
    }],
    "343e4edc": [{
      "hkey": "ed78c8c1",
      "slug": "nizza-millefonti",
      "name": "Nizza Millefonti",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "9eab6003",
      "slug": "filadelfia-lingotto",
      "name": "Filadelfia, Lingotto",
      "primary": true,
      "skipSearch": false
    }],
    "lingotto": [{
      "hkey": "9eab6003",
      "slug": "filadelfia-lingotto",
      "name": "Filadelfia, Lingotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torino"
    }],
    "dde04dde": [{
      "hkey": "355e6d5e",
      "slug": "borgo-vittoria-madonna-di-campagna",
      "name": "Borgo Vittoria, Madonna Di Campagna",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "b7d23f7e",
      "slug": "lucento-vallette-juventus-stadium",
      "name": "Lucento, Vallette, Juventus Stadium",
      "primary": false,
      "skipSearch": false
    }],
    "madonna-campagna": [{
      "hkey": "355e6d5e",
      "slug": "borgo-vittoria-madonna-di-campagna",
      "name": "Borgo Vittoria, Madonna Di Campagna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torino"
    }],
    "18db5ad4": [{
      "hkey": "9eab6003",
      "slug": "filadelfia-lingotto",
      "name": "Filadelfia, Lingotto",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "09ab431b",
      "slug": "mirafiori-santa-rita",
      "name": "Mirafiori, Santa Rita",
      "primary": true,
      "skipSearch": false
    }],
    "citta-giardino-centro-europa": [{
      "hkey": "09ab431b",
      "slug": "mirafiori-santa-rita",
      "name": "Mirafiori, Santa Rita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torino"
    }],
    "mirafiori-nord": [{
      "hkey": "09ab431b",
      "slug": "mirafiori-santa-rita",
      "name": "Mirafiori, Santa Rita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torino"
    }],
    "e2c6efc6": [{
      "hkey": "9eab6003",
      "slug": "filadelfia-lingotto",
      "name": "Filadelfia, Lingotto",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "09ab431b",
      "slug": "mirafiori-santa-rita",
      "name": "Mirafiori, Santa Rita",
      "primary": true,
      "skipSearch": false
    }],
    "mirafiori-sud": [{
      "hkey": "09ab431b",
      "slug": "mirafiori-santa-rita",
      "name": "Mirafiori, Santa Rita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torino"
    }],
    "ddae81b8": [{
      "hkey": "232b900e",
      "slug": "pozzo-strada-borgata-lesna",
      "name": "Pozzo Strada, Borgata Lesna",
      "primary": true,
      "skipSearch": false
    }],
    "pozzo-strada": [{
      "hkey": "232b900e",
      "slug": "pozzo-strada-borgata-lesna",
      "name": "Pozzo Strada, Borgata Lesna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torino"
    }],
    "dbed8f26": [{
      "hkey": "bcce8904",
      "slug": "madonna-del-pilone-sassi",
      "name": "Madonna del Pilone, Sassi",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "4707f07c",
      "slug": "borgo-po-cavoretto",
      "name": "Borgo Po, Cavoretto",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "f4995c32",
      "slug": "superga-colle-della-maddalena-precollina",
      "name": "Superga, Colle della Maddalena, Precollina",
      "primary": true,
      "skipSearch": false
    }],
    "da049b6e": [{
      "hkey": "020c3495",
      "slug": "barriera-di-milano-rebaudengo",
      "name": "Barriera di Milano, Rebaudengo",
      "primary": true,
      "skipSearch": false
    }],
    "barriera-di-milano-rebaduengo": [{
      "hkey": "020c3495",
      "slug": "barriera-di-milano-rebaudengo",
      "name": "Barriera di Milano, Rebaudengo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e4487329": [{
      "hkey": "062e336f",
      "slug": "rebaudengo",
      "name": "Rebaudengo",
      "primary": true,
      "skipSearch": false
    }],
    "rebaduengo": [{
      "hkey": "062e336f",
      "slug": "rebaudengo",
      "name": "Rebaudengo",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": null
    }],
    "precollina": [{
      "hkey": "f4995c32",
      "slug": "superga-colle-della-maddalena-precollina",
      "name": "Superga, Colle della Maddalena, Precollina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torino"
    }],
    "72cca16d": [{
      "hkey": "cb6d25b8",
      "slug": "barca-bertolla",
      "name": "Barca, Bertolla",
      "primary": true,
      "skipSearch": false
    }],
    "bertolla": [{
      "hkey": "cb6d25b8",
      "slug": "barca-bertolla",
      "name": "Barca, Bertolla",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torino"
    }],
    "d3fff671": [{
      "hkey": "cb6d25b8",
      "slug": "barca-bertolla",
      "name": "Barca, Bertolla",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "9633ba93",
      "slug": "regio-parco",
      "name": "Regio Parco",
      "primary": false,
      "skipSearch": false
    }],
    "regio-parco-barca": [{
      "hkey": "cb6d25b8",
      "slug": "barca-bertolla",
      "name": "Barca, Bertolla",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torino"
    }],
    "fa458791": [{
      "hkey": "d023af7d",
      "slug": "campidoglio-cit-turin-san-donato",
      "name": "Campidoglio, Cit Turin, San Donato",
      "primary": true,
      "skipSearch": false
    }],
    "san-donato": [{
      "hkey": "d023af7d",
      "slug": "campidoglio-cit-turin-san-donato",
      "name": "Campidoglio, Cit Turin, San Donato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torino"
    }],
    "d1233e1b": [{
      "hkey": "be7006ff",
      "slug": "borgo-san-paolo-cenisia",
      "name": "Borgo San Paolo, Cenisia",
      "primary": true,
      "skipSearch": false
    }],
    "san-paolo": [{
      "hkey": "be7006ff",
      "slug": "borgo-san-paolo-cenisia",
      "name": "Borgo San Paolo, Cenisia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torino"
    }],
    "ab3277eb": [{
      "hkey": "6eb18614",
      "slug": "san-salvario",
      "name": "San Salvario",
      "primary": true,
      "skipSearch": false
    }],
    "san-salvario-parco-valentino": [{
      "hkey": "6eb18614",
      "slug": "san-salvario",
      "name": "San Salvario",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torino"
    }],
    "0ef11f8f": [{
      "hkey": "09ab431b",
      "slug": "mirafiori-santa-rita",
      "name": "Mirafiori, Santa Rita",
      "primary": true,
      "skipSearch": false
    }],
    "santa-rita": [{
      "hkey": "09ab431b",
      "slug": "mirafiori-santa-rita",
      "name": "Mirafiori, Santa Rita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torino"
    }]
  }
};
exports["default"] = _default;